import React from 'react';
import { IMAGES } from 'src/shared/utils/appConstant';
import { IOT_STRINGS, cardDataSmartSecurity } from 'src/shared/utils/string';
import IOTServicePage from './IOTServicePage';

const SmartSecurityMonitoring: React.FC = () => {
  return (
    <IOTServicePage
      title={IOT_STRINGS.SMART_SECURITY_MONITORING}
      backgroundImage={IMAGES.SMART_SECURITY_BANNER}
      cardData={cardDataSmartSecurity}
    />
  );
};

export default SmartSecurityMonitoring;